
import React, { useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    TextField,
    Typography
} from '@mui/material';
import store from '../../store';

export function TourLeader() {
    const [formData, setFormData] = useState({
        name: store.tourLeader.name || '',
        email: store.tourLeader.email || '',
        phone: store.tourLeader.phone || '',
    });

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    };

    const handleSubmit = () => {
        store.saveFormRegisterDetails(formData)
    };

    return (
        <div className="step-content step-content--narrow">
            <Box
                component="form"
                className="tour-leader-form"
                sx={{
                    width: '100%',
                    direction: 'rtl',
                }}
                noValidate
                autoComplete="off"
            >
                <Typography className="tour-leader-copy">יש למלא את ההסכם המצורף עם פרטי כל הנוסעים.
                    לאחר שליחת הטופס נעבור על הפרטים לבדוק אם יש נושאים לא ברורים או שאלות וניצור קשר בהתאם.
                    לאחר תחילת הטיפול בסגירת הלינות ישלח קישור  שיאפשר מעקב בכל זמן אחרי ההתקדמות.</Typography>
                <Typography className="tour-leader-copy tour-leader-copy--strong"><strong>מאוד חשוב שבטופס זה יצויין כל דבר שרלוונטי לנסיעה שלכם על מנת שיהיה ניתן לתת להכול מענה כמה שניתן כבר מהשלבים הראשונים.</strong></Typography>
                <FormControl className="tour-leader-fields">
                    <TextField
                        id="full-name"
                        required
                        label="שם מלא בעברית של ממלא הטופס "
                        value={formData.name}
                        name="name"
                        variant="outlined"
                        fullWidth
                        onChange={handleInputChange}
                    />
                    <TextField
                        id="email"
                        required
                        label="אימייל"
                        name="email"
                        variant="outlined"
                        value={formData.email}
                        fullWidth
                        onChange={handleInputChange}
                    />
                    <TextField
                        id="phone"
                        required
                        label="מספר טלפון"
                        value={formData.phone}
                        name="phone"
                        variant="outlined"
                        fullWidth
                        onChange={handleInputChange}
                    />
                    <Button
                        variant='contained'
                        type='submit'
                        onClick={handleSubmit}
                        sx={{ width: '120px', alignSelf: 'center' }}
                    >
                        שמור
                    </Button>
                </FormControl >
            </Box >
        </div>
    )
}
